/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandSafari = createReactComponent("brand-safari", "IconBrandSafari", [
  ["path", { d: "M8 16l2 -6l6 -2l-2 6l-6 2", key: "svg-0" }],
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-1" }]
]);

export { IconBrandSafari as default };
//# sourceMappingURL=IconBrandSafari.js.map
